import { render } from "./create-payin.vue?vue&type=template&id=6b21b62a&scoped=true"
import script from "./create-payin.vue?vue&type=script&lang=js"
export * from "./create-payin.vue?vue&type=script&lang=js"

import "./create-payin.vue?vue&type=style&index=0&id=6b21b62a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b21b62a"]])

export default __exports__